import { createMuiTheme } from "@material-ui/core";
import purple from "@material-ui/core/colors/purple";
import green from "@material-ui/core/colors/green";
import IRANSansWeb from "./font/IRANSansWeb/IRANSansWeb.woff2";

const sans = {
  fontFamily: "persianFontIranSansWeb",
  fontStyle: "normal",

  fontWeight: 400,
  src: `
    local('persianFontIranSansWeb'),
    local('IRANSansWeb'),
    url(${IRANSansWeb}) format('woff2')
  `,
};

const theme = createMuiTheme({
  direction: "rtl",
  palette: {
    /*
    primary: {
      main: purple[500],
    },
    */
    secondary: {
      main: "#e0e0e0",
    },
  },

  typography: {
    fontFamily: [
      "persianFontIranSansWeb",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  overrides: {
    MuiListItemIcon: {
      root: {
        minWidth: "35px",
      },
    },
    MuiCssBaseline: {
      "@global": {
        "@font-face": [sans],
      },
    },
  },
});
export default theme;
